<template>
  <div style="max-height: 1920px;">
    <v-row>
      <v-col cols="12" md="12" style="text-align: center;">
        <v-row>
          <v-col cols="12" md="12" style="text-align: center;">
            <v-img alt="Logo" class="shrink mr-2 app" contain :src="logoimage" transition="scale-transition"
              width="1000" />
          </v-col>
        </v-row>
        <v-sheet class="folded-corner" width="1045" height="1100" style="margin-top: 250px">
          <v-container>
            <v-row>
              <v-card elevation="0" width="866" height="1100" style="
                background-color: white;
              " class="align-center pa-4 mx-auto">
                <!-- <v-row style="margin-top: 5%">
                  <v-col cols="12" md="12" style="
                    text-align: left;
                    font-size: 60px;
                    color: #344054;
                    font-weight: bold;
                    padding-left: 20px;
                  ">
                    {{ $t("message.companynames") }} <br>
                    {{ $i18n.locale == 'en' ? ShowData : ShowDataTh }}
                  </v-col>
                </v-row> -->
                <v-row >
                  <v-col cols="12" md="12" style="text-align: center;">
                    <span style="color: #344054;font-size: 60px;font-weight: 800;">
                      {{ "รายชื่อบริษัท" }}
                    </span>
                    <br>
                    <span style="color: #898A8C;font-size: 40px;font-weight: 700;">{{ "LIST OF COMPANY NAMES" }}</span>
                  </v-col>
                </v-row>
                <v-row style="display: flex;justify-content: center;">
                  <v-col cols="7" md="7">

                    <v-divider style="border-top-width: 8px !important;border-color: #344054; "></v-divider>
                  </v-col>
                </v-row>
                      <v-row style="display: flex;justify-content: center;">
                  <v-col cols="12" md="12">
                      <v-sheet height="30" v-if="ShowData == ''"> </v-sheet>
                       <span v-else style="color: #344054;font-size: 20px;font-weight: 800;">
                      {{ ShowData }}
                    </span>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="12" style="text-align: center">
                    <v-text-field outlined v-model="SearchTenant" ref="inputTenant" height="70"></v-text-field>

                    <v-virtual-scroll v-model="selectedItem" color="primary" v-if="SearchTenant != ''" :items="TenantList" height="170" item-height="48">
                      <template v-slot:default="{ item }">
                     
                          <v-list-item :key="item" @click="
                            dataTenant(item)
                            ">
                            <v-list-item-content style="text-align: start;">
                              <v-list-item-title>
                                <v-row>
                                    <v-col cols="5" md="5" sm="5">
                                    <strong>{{ item.nameEng }} </strong>
                                  </v-col>
                                  <v-col cols="5" md="5" sm="5">
                                    <strong>{{ item.nameThai == '-' ? '' : item.nameThai }} </strong>
                                  </v-col>
                                
                                  <v-col cols="1" md="1" sm="1">
                                    {{ $t("message.Floor") }} :
                                  </v-col>

                                  <v-col cols="1" md="1" sm="1">
                                    <strong> {{ item.floorID }} </strong>
                                  </v-col>
                                </v-row>
                              </v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                      </template>
                    </v-virtual-scroll>
                    <v-sheet height="170" v-if="SearchTenant == ''"> </v-sheet>

                  </v-col>
                </v-row>
                <v-row style="margin-top: 3%">

                  <div style="width: 100%; padding-left: 10px; padding-right: 10px">
                    <MultiSimpleKeyboardTenant @onChange="onChangeTenant" />
                  </div>
                </v-row>
                <v-row style="margin-top: 5%">
                  <v-col cols="6" md="6" lg="6" sm="6" style="text-align: center">
                    <v-btn color="#344054" class="box white--text mt-2 text-capitalize" router 
                      style="font-size: 45px; " height="100" @click="BackToIdentifySelection()">{{
                        $t("message.Back")
                      }}</v-btn>
                  </v-col>
                  <v-col cols="6" md="6" lg="6" sm="6" style="text-align: center">
                    <v-btn color="#344054" class="box white--text mt-2 text-capitalize" router 
                      style="font-size: 45px; " height="100" :disabled="ShowData == ''" @click="printQr()">{{
                        $t("message.Continue") }}</v-btn>
                  </v-col>
                </v-row>
              </v-card>
            </v-row>

          </v-container>
        </v-sheet>
      </v-col>
    </v-row>


    <v-dialog v-model="LoadingDialog" persistent width="300">
      <v-card color="#1D2939" dark>
        <v-card-text class="white--text">
          <v-row>
            <p style="text-align: center">Loading</p>
          </v-row>
          <v-row>
            <v-progress-linear indeterminate color="#ffffff" class="mb-0"></v-progress-linear>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import axios from "axios";
import enurl from "@/api/environment";
import MultiSimpleKeyboardTenant from "@/components/MultiSimpleKeyboard";
// import logoimage from "@/assets/OneBangkokLogo.png";
// import ChangeLanguage from "@/components/ChangeLanguage";
export default {
  name: "FindingTenant",
  components: {
    MultiSimpleKeyboardTenant,
    // ChangeLanguage,
  },
  data() {
    return {
      url: enurl.apiUrl,
      settingUrl: enurl.settingUrl,
      DefaultLogo: "@/assets/logo192.png",
      DefaultBG: "@/assets/1D2939.png",
      Datetime: "",
      LoadingDialog: false,
      selectedItem: null,

      inputTenantName: "",
      TenantName: "",
      Textkeyboard: "",
      SearchTenant: "",
      ShowData: "",
      ShowDataTh: "",
      TenantList: [],
      TenantListName: [],
      data: [],
      zoneName: "",
      tenantName: "",
      floorID: "",
      lang: "en",
      logoimage: "",
    };
  },

  mounted: function () {
    let self = this;
    console.log(self.$route.params.data);
    self.data = self.$route.params.data;
    self.lang = localStorage.getItem("lang");
    self.logoimage = require("@/assets/OneBangkokLogo.png");

    self.$refs.inputTenant.focus();
    // this.SearchDataTenant();
  },

  watch: {
    // SearchTenant: function (value) {
    //     let self = this;
    //     if(value.length > 3){
    //         self.SearchDataTenant(value);
    //     }
    // }

    '$i18n.locale'(newLocale, oldLocale) {
      console.log(`เปลี่ยนภาษา: ${oldLocale} → ${newLocale}`);
    }

  },

  methods: {
    dataTenant(item) {
      // let data = input.replace("undefined", "");
      // this.SearchTenant = data;
      let self = this;
      let textTh = item.nameThai == "-" ? "" : item.nameThai;


      let text = item.nameEng  + '  ' + textTh + '  ' + 'F. ' + item.floorID;

      



      self.zoneName = item.zoneName;
      self.tenantName = item.tenantName;


      if (self.data != null) {
        if (self.data.documentNumber != undefined && self.data.documentNumber != "") {
          self.data.zoneID = item.zoneID;
          self.data.floorID = item.floorID;
          self.data.locationID = item.locationID;
          self.data.tenantID = item.tenantID;
          self.data.referenceQr = localStorage.getItem("LogId");
          self.data.ip = localStorage.getItem("IP");
        }
      }
      this.ShowData = text;
      this.ShowDataTh = textTh;
    },
    getCurrentDate() {
      let self = this;
      let newDate = new Date();
      let date =
        newDate.getDate() < 10 ? "0" + newDate.getDate() : newDate.getDate();
      let month = newDate.getMonth() + 1;
      let year =
        newDate.getFullYear() < 2500
          ? newDate.getFullYear() + 543
          : newDate.getFullYear();
      let hours =
        newDate.getHours() < 10 ? "0" + newDate.getHours() : newDate.getHours();
      let minutes =
        newDate.getMinutes() < 10
          ? "0" + newDate.getMinutes()
          : newDate.getMinutes();
      let seconds =
        newDate.getSeconds() < 10
          ? "0" + newDate.getSeconds()
          : newDate.getSeconds();
      self.Datetime = `${date}/${month < 10 ? `0${month}` : `${month}`
        }/${year}  ${hours}:${minutes}:${seconds}`;
    },

    select() {
      this.$refs.inputTenant.select();
    },

    onChangeTenant(input) {
      let self = this;
      self.SearchTenant = input;
      self.SearchDataTenant();
    },

    BackToIdentifySelection() {
      let self = this;
      self.$router.push("/MainMenu");
      // self.$router.push("/CapturePerson");
    },
    printQr() {
      let self = this;
      // self.$router.push("/PrintQr");
      self.$router.push({
        name: "PrintQr",
        path: "/PrintQr",
        params: {
          data: self.data,
          zoneName: self.zoneName,
          tenantName: self.tenantName,
        },
      });
    },

    CapturePerson() {
      let self = this;
      self.$router.push("/CapturePerson");
    },

    // SearchDataTenant(value) {
    //   let self = this;
    //   let temp = {
    //     search: value,
    //   };
    //   axios
    //     .post(`${self.url}Main/searchDataTenant`, temp)
    //     .then(function(response) {
    //       if (response.data.status == 0) {
    //         self.TenantList = response.data.data;
    //         console.log(response.data.data);
    //       }
    //     })
    //     .catch(function(error) {
    //       self.MessageAlert = error;
    //     });
    // },

    SearchDataTenant() {
      let self = this;
      let temp = {
        search: self.SearchTenant,
        lang: 'en',
      };
      axios
        .post(`${self.url}VMS/searchDataTenant`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            self.TenantList = response.data.data;
            // console.log(self.TenantList);
          }
          if (response.data.status == 1) {
            self.TenantList = [];
          }
        })
        .catch(function (error) {
          self.MessageAlert = error;
        });
    },
  },
};
</script>
<style scoped>
.v-input input {
  font-size: 2.2em !important;
}

@media all and (orientation: portrait) {
  .fullscreen {
    height: 1890px;
  }
}

@media all and (orientation: landscape) {
  .fullscreen {
    height: auto;
  }
}
</style>
